import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@providers/authProvider';

/**
 * Generic RBAC route guard. Renders children only when the authenticated user
 * has the required role; otherwise redirects to /app. Used with the
 * shared/rbac.json config to gate admin-only routes.
 */
function RoleRoute({ role, children }) {
    const { hasRole, user } = useAuth();
    if (user === undefined) return null;
    if (!hasRole(role)) return <Navigate to="/app" replace />;
    return children;
}

RoleRoute.propTypes = {
    role: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
};

export default RoleRoute;
